/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const DoneIcon = ({
  className,
  style,
  color = '#6ABAA4',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0485 2.85181L4.97801 10.4155C4.79369 10.6126 4.49603 10.6114 4.3132 10.4126L0.948855 6.75513C0.766022 6.55636 0.767197 6.23536 0.951519 6.03819L1.2853 5.68116C1.46962 5.48399 1.76728 5.48526 1.95011 5.68403L4.6523 8.62163L11.0552 1.77205C11.2396 1.57488 11.5372 1.57614 11.7201 1.77492L12.0511 2.13487C12.234 2.33364 12.2328 2.65464 12.0485 2.85181Z"
        fill={color}
      />
    </svg>
  );
};
